export default {
  containers: {
    location_info: 'Sijainnin tiedot',
    attributes: 'Ominaisuudet',
    links: 'Linkit',
  },
  labels: {
    title: 'Otsikko',
    phone_number: 'Puhelinnumero',
    description: 'Kuvaus',
    website: 'Verkkosivusto',
    address: 'Osoite',
    regular_hours: 'Aukioloajat',
    page_urls: 'Sivun URL-osoitteet',
    monday: 'Maanantai',
    tuesday: 'Tiistai',
    wednesday: 'Keskiviikko',
    thursday: 'Torstai',
    friday: 'Perjantai',
    saturday: 'Lauantai',
    sunday: 'Sunnuntai',
    twenty_four_hours: '24 h',
    open_24_hours: 'Auki 24 tuntia',
    open_time: 'Avautumisaika',
    close_time: 'Sulkemisaika',
    url: 'URL-osoite',
    provider_type: 'Palveluntarjoajan tyyppi',
    provider_types: {
      merchant: 'Kauppias',
      aggregator: 'Kokoaja',
    },
    place_action_type: 'Tyyppi',
    is_preferred: 'Suositeltu',
    place_action_types: {
      appointment: 'Ajanvaraus',
      online_appointment: 'Verkossa tapahtuva ajanvaraus',
      dining_reservation: 'Varauslinkki',
      food_ordering: 'Ruoan tilaaminen kotiinkuljetuksena ja/tai noutona',
      food_delivery: 'Toimituslinkki',
      food_takeout: 'Noutolinkki',
      shop_online: 'Ostokset, jotka voivat olla kotiinkuljetus ja/tai nouto',
    },
    no_links: 'Tälle yritykselle ei ole saatavilla linkkejä',
    url_menu: 'Ruokalistan linkki',
    url_reservations: 'Varauslinkki',
  },
  placeholders: {
    title: 'Otsikko',
    phone_number: 'Puhelinnumero',
    description: 'Kuvaus',
    website: 'Verkkosivusto',
    address: 'Osoite',
    regular_hours: 'Aukioloajat',
    page_urls: 'Sivun URL-osoitteet',
    address_line_1: 'Osoiterivi 1',
    postal_code: 'Postinumero',
    locality: 'Paikkakunta',
    region_code: 'Alueen koodi',
    language_code: 'Kielikoodi',
    select_time: 'Valitse aika',
    url: 'URL-osoite',
  },
  buttons: {
    submit: 'Lähetä',
    add: 'Lisää',
    delete: 'Poista',
    generate_description: 'Luo kuvaus tekoälyllä',
  },
  validation: {
    required: 'Tämä kenttä on pakollinen',
    invalid_url: 'Virheellinen URL-osoite',
  },
  toasts: {
    success: 'Muutokset tallennettu!',
    description_generation_failed: 'Kuvausta ei voitu luoda. Yritä uudelleen.',
  },
};
